import React, {Component, ReactNode} from 'react';
import I18n from 'app/i18n';
import {inject, observer} from 'mobx-react';
import BuyButton from 'app/components/shop/lootboxes/buy_button';
import {scrollToTop} from 'app/utils';
import {currencyItem} from 'app/utils/ShopItemPriceFormat';
import withRouter from 'app/utils/navigate/customWithRouter';
import GoBackButton from 'app/components/reusable/GoBackButton';
import ShopItemDetailsHeader from 'app/components/shop/ShopItemDetailsHeader';
import SetContents from 'app/components/shop/SetContents';
import {OtherItemStore} from 'app/store/OtherItemStore';
import {otherItemDescription} from 'app/components/my_profile/artifacts/otherItemDescription';
import {otherItemName} from 'app/components/my_profile/artifacts/otherItemName';
import OtherItemInterface from 'app/interfaces/shop/OtherItemInterface';

interface OtherItemDetailsProps {
    otherItemStore?: OtherItemStore;
    isSet?: boolean
    params?: {
        id: string;
    }
}

class OtherItemDetails extends Component<OtherItemDetailsProps> {
    componentDidMount(): void {
        this.loadItem();
        scrollToTop();
    }

    componentWillUnmount(): void {
        this.props.otherItemStore?.updateItem(null);
    }

    componentDidUpdate(prevProps: OtherItemDetailsProps): void {
        if (this.props.params?.id !== prevProps.params?.id) {
            this.loadItem();
        }
    }

    loadItem = (): void => {
        const {params, otherItemStore} = this.props;

        if (params?.id) {
            otherItemStore?.getItem(params.id);
        }
    };

    get currency(): string {
        return new URLSearchParams(location.search).get('currency') || '';
    }

    get isSet(): boolean {
        return Boolean(this.props.isSet);
    }

    itemDescription = (item: OtherItemInterface): string => otherItemDescription({
        content_langs: item.content_langs,
        description: item.description
    });

    renderMeta = (item: OtherItemInterface): ReactNode => {
        const count = item.set_items?.length || 0;

        if (!this.isSet || count === 0) {
            return null;
        }

        const label = [I18n.t('shop.set_equipment'), I18n.t('shop.lootbox_items_count', {count})].join(' · ');

        return <p className="shop-item-detail__meta">{label}</p>;
    };

    renderActions = (item: OtherItemInterface): ReactNode => <div className="shop-item-detail__actions">
        <BuyButton
            {...item}
            currency={currencyItem(this.currency)}
            customText={I18n.t(this.isSet ? 'shop.buy_set' : 'buy')}
            show_loading={false}
            hidePrice
            className="shop-item-detail__btn"
        />
    </div>;

    render(): ReactNode {
        const {otherItemStore} = this.props;
        const item = otherItemStore?.item;

        if (!item) {
            return null;
        }

        const {langs, title} = item;
        const description = this.itemDescription(item);

        return <div className="market-details shop-item-detail">
            <GoBackButton label={I18n.t('shop.back_to_store')}/>
            <ShopItemDetailsHeader
                artifact={item}
                title={otherItemName({langs, title})}
                currency={this.currency}
                cost_money={item.cost_money}
                cost_points={item.cost_points}
                previewVariant={this.isSet ? 'set' : 'other'}
                meta={this.renderMeta(item)}
                actions={this.renderActions(item)}
            />
            {(description || this.isSet) && <div className="shop-item-detail__content">
                {description && <div
                    className="shop-item-detail__description"
                    dangerouslySetInnerHTML={{__html: description}}
                />}
                {this.isSet && <SetContents items={item.set_items ?? []}/>}
            </div>}
        </div>;
    }
}

export default withRouter(inject('otherItemStore')(observer(OtherItemDetails)));
